import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from '@app/material.module';
import { NgxEchartsModule } from 'ngx-echarts';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';

/**
 * Old code. Needs a looking at
 */
import { BarChartComponent } from './charts/bar-chart/bar-chart.component';
import { LineChartComponent } from './charts/line-chart/line-chart.component';
import { PolarBarChartComponent } from './charts/polar-bar-chart/polar-bar-chart.component';
import { SignPostChartComponent } from './charts/sign-post-chart/sign-post-chart.component';
import { EnergyPhasesChartComponent } from './charts/energy-phases-chart/energy-phases-chart.component';

import { WidgetCardWrapperComponent } from './widget-card-wrapper/widget-card-wrapper.component';

/**
 * Widget components
 */
import { WidgetMaramatakaPhaseComponent } from './maramataka-phase/widget-maramataka-phase.component';
import { WidgetMonitoringInformationComponent } from './monitoring-information/widget-monitoring-information.component';
import { WidgetTaiaoScorecardComponent } from '../legacy-widgets/taiao-scorecard/widget-taiao-scorecard.component';
import { WidgetKokopuComponent } from './kokopu/widget-kokopu.component';
import { WidgetStatusBadgeComponent } from './status-badge/widget-status-badge.component';
import { BasicCartesianChartComponent } from './basic-cartesian-chart/basic-cartesian-chart.component';
import { AggregateCartesianChartComponent } from './aggregate-cartesian-chart/aggregate-cartesian-chart.component';
import { BasicScatterChartComponent } from './basic-scatter-chart/basic-scatter-chart.component';
import { BasicPieChartComponent } from './basic-pie-chart/basic-pie-chart.component';
import { WeatherHistoricalChartComponent } from './weather-chart/weather-historical-chart.component';
import { WeatherForecastChartComponent } from './weather-chart/weather-forecast-chart.component';
import { RongoMauriChartComponent } from './rongo-mauri-chart/rongo-mauri-chart.component';
import { RongoWaiQualityChartComponent } from './rongo-wai-quality-chart/rongo-wai-quality-chart.component';
import { RongoPestCountChartComponent } from './rongo-pest-count-chart/rongo-pest-count-chart.component';
import { HonongaCountChartComponent } from './rongo-hononga-chart/rongo-hononga-chart.component';
import { RongoKaupapaChartComponent } from './rongo-kaupapa-chart/rongo-kaupapa-chart.component';
import { RongoTaongaAbundanceChartComponent } from './rongo-taonga-abundance-chart/rongo-taonga-abundance-chart.component';
import { WaiMauriComponent } from './rongo-wai-mauri/rongo-wai-mauri.component';
import { MauriComponent } from './rongo-mauri/rongo-mauri.component';
import { RongoRiparianFeaturesChartComponent } from './rongo-riparian-features-chart/rongo-riparian-features-chart.component';
import { WindBarbChartComponent } from './wind-barb-chart/wind-barb-chart.component';
import { BasicPolarBarChartComponent } from './basic-polar-bar-chart/basic-polar-bar-chart.component';
import { BasicBarChartComponent } from './basic-bar-chart/basic-bar-chart.component';
import { MacrophytesPieChartComponent } from './macrophytes-pie-chart/macrophytes-pie-chart.component';
import { MacrophytesBarChartComponent } from './macrophytes-bar-chart/macrophytes-bar-chart.component';
import { BasicSunburstChartComponent } from './basic-sunburst-chart/basic-sunburst-chart.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    LeafletModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
    MaterialModule,
  ],
  declarations: [
    BasicCartesianChartComponent,
    AggregateCartesianChartComponent,
    BarChartComponent,
    LineChartComponent,
    PolarBarChartComponent,
    SignPostChartComponent,
    EnergyPhasesChartComponent,
    WidgetCardWrapperComponent,
    WidgetMaramatakaPhaseComponent,
    WidgetMonitoringInformationComponent,
    WidgetTaiaoScorecardComponent,
    WidgetKokopuComponent,
    WidgetStatusBadgeComponent,
    BasicScatterChartComponent,
    BasicPieChartComponent,
    BasicSunburstChartComponent,
    WeatherHistoricalChartComponent,
    WeatherForecastChartComponent,
    RongoMauriChartComponent,
    RongoWaiQualityChartComponent,
    RongoPestCountChartComponent,
    HonongaCountChartComponent,
    RongoKaupapaChartComponent,
    RongoTaongaAbundanceChartComponent,
    WaiMauriComponent,
    MauriComponent,
    RongoRiparianFeaturesChartComponent,
    WindBarbChartComponent,
    BasicPolarBarChartComponent,
    BasicBarChartComponent,
    MacrophytesPieChartComponent,
    MacrophytesBarChartComponent,
  ],
  exports: [
    WidgetMaramatakaPhaseComponent,
    WidgetMonitoringInformationComponent,
    WidgetTaiaoScorecardComponent,
    WidgetKokopuComponent,
    WidgetStatusBadgeComponent,
    BasicCartesianChartComponent,
    AggregateCartesianChartComponent,
    WidgetCardWrapperComponent,
    BasicScatterChartComponent,
    BasicPieChartComponent,
    BasicSunburstChartComponent,
    WeatherHistoricalChartComponent,
    WeatherForecastChartComponent,
    RongoMauriChartComponent,
    RongoWaiQualityChartComponent,
    RongoPestCountChartComponent,
    HonongaCountChartComponent,
    RongoKaupapaChartComponent,
    RongoTaongaAbundanceChartComponent,
    WaiMauriComponent,
    MauriComponent,
    RongoRiparianFeaturesChartComponent,
    WindBarbChartComponent,
    BasicPolarBarChartComponent,
    BasicBarChartComponent,
    MacrophytesPieChartComponent,
    MacrophytesBarChartComponent,
  ],
})
export class WidgetsModule {}
